<nav class="navbar navbar-expand-lg ">
  <div class="container-fluid">
      <a class="navbar-brand" routerLink="/">
        <img ngSrc="assets/img/medilinkLogo.svg" alt="MediLink Logo" width="150" height="50">
      </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse  navbar-collapse ms-lg-auto " id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="activeRoute"  routerLink="/promociones"><span>Promociones</span></a>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Servicios
          </a>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item"  routerLinkActive="activeRoute" routerLink="/movilink">Movilink</a></li>
            <li><a class="dropdown-item"  routerLinkActive="activeRoute" routerLink="/onlink">Onlink</a></li>
            <li><a class="dropdown-item"  routerLinkActive="activeRoute" routerLink="/terapiafisica">Terapia Física</a></li>
          </ul>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="activeRoute" style="color: var(--bs-red);"  routerLink="/ambulancia"><span>Ambulancia</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="activeRoute" routerLink="/especialidades">Especialidades</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="activeRoute" routerLink="/nosotros">Nosotros</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="activeRoute" routerLink="/contactanos">Contáctanos</a>
        </li>
      </ul>

        <a href="https://serviciosenlinea.medilink.com.ec" target="_blank" class="btn-getstarted ">Servicios en Línea <i class="bi bi-arrow-up-right-circle-fill"></i></a>

    </div>
  </div>
</nav>



